import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
const SvgLucideListTree = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <g
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    >
      <path d="M8 5h13m-8 7h8m-8 7h8M3 10a2 2 0 0 0 2 2h3" />
      <path d="M3 5v12a2 2 0 0 0 2 2h3" />
    </g>
  </svg>
);
const ForwardRef = forwardRef(SvgLucideListTree);
const Memo = memo(ForwardRef);
export default Memo;
